import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { AppToaster } from './components/AppToaster'
import { initAnalytics } from './lib/analytics'
import { initGlitchTip } from './lib/glitchtip'
import { queryClient } from './lib/queryClient'
import App from './App'
import './index.css'

initGlitchTip()
void initAnalytics()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <QueryClientProvider client={queryClient}>
        <App />
        <AppToaster />
      </QueryClientProvider>
    </BrowserRouter>
  </StrictMode>,
)
